export default "__VITE_ASSET__DrqRSinh__"